// ============================================================
// Firebase Client SDK — Frontend initialization
// ============================================================

import { initializeApp } from 'firebase/app';
import {
    getAuth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signInWithPopup,
    GoogleAuthProvider,
    signOut,
    type User as FirebaseUser,
} from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBgCbHNizY37ZQMav1LbU1FskyJGHJ9Ieg",
    authDomain: "hirehub-2027.firebaseapp.com",
    projectId: "hirehub-2027",
    storageBucket: "hirehub-2027.firebasestorage.app",
    messagingSenderId: "109598885089",
    appId: "1:109598885089:web:56b34d79e6b3096c3363a0",
    measurementId: "G-C4SVB89KSG",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

/**
 * Sign in with email/password via Firebase, return the ID token.
 */
export async function firebaseSignInWithEmail(email: string, password: string): Promise<string> {
    const credential = await signInWithEmailAndPassword(auth, email, password);
    return credential.user.getIdToken();
}

/**
 * Create account with email/password via Firebase, return the ID token.
 */
export async function firebaseSignUpWithEmail(email: string, password: string): Promise<string> {
    const credential = await createUserWithEmailAndPassword(auth, email, password);
    return credential.user.getIdToken();
}

/**
 * Sign in with Google popup, return the ID token.
 */
export async function firebaseSignInWithGoogle(): Promise<{ idToken: string; user: FirebaseUser }> {
    const result = await signInWithPopup(auth, googleProvider);
    const idToken = await result.user.getIdToken();
    return { idToken, user: result.user };
}

/**
 * Sign out of Firebase.
 */
export async function firebaseSignOut() {
    await signOut(auth);
}
